export default __webpack_public_path__ + "static/media/Deliveroo_logo.d01fc3dd.png";